var selectedShape;
var selectedShapeIndexInArray = -1;
var _shapes = [];
var existingCircleList = [];
var existingPolygonList = [];

// Optional
function getShapes() {
  var shapeList = [];
  var radiusNVertices = getShapeRadiusNVertices();

  for (var i = 0; i < radiusNVertices.length; i++) {
    var shapeType = radiusNVertices[i].type === "circle" ? 1 : 2;

    var circleRadius = null;
    var circleLatLang = null;
    if (shapeType === 1) {
      var circleObj = JSON.parse(radiusNVertices[i].circle);
      circleRadius = circleObj.radius;
      circleLatLang = JSON.stringify(circleObj.center);
    }

    var polygonVertices =
      radiusNVertices[i].type === "circle" ? null : radiusNVertices[i].polygon;

    shapeList.push({
      ShapeType: shapeType,
      CircleRadius: circleRadius,
      CircleLatLong: circleLatLang,
      PolygonVertices: polygonVertices,
    });
  }
  return shapeList;
}

function clearSelection() {
  if (selectedShape) {
    selectedShape.setEditable(false);
    selectedShape.setDraggable(false);
    // selectedShape.fillColor= '#BCDCF9';
    // selectedShape.strokeColor= '#57ACF9';
    selectedShape = null;
  }
}

function setSelection(shape) {
  clearSelection();
  if (shape !== null) {
    selectedShape = shape;
    shape.setEditable(true);
    shape.setDraggable(true);
    // shape.fillColor= '#ffd1d1';
    // shape.strokeColor= '#ff9595';

    selectedShapeIndexInArray = arrayIndexOfValue(_shapes, selectedShape);

    if (shape.type === "polygon") {
      document
        .getElementById("pac-remove-line-seg")
        .removeAttribute("disabled");
    } else {
      document
        .getElementById("pac-remove-line-seg")
        .setAttribute("disabled", "disabled");
    }
    if (selectedShape !== null) {
      document.getElementById("pac-remove-shape").removeAttribute("disabled");
      //$('#pac-remove-shape').prop("disabled", false);
    } else {
      document
        .getElementById("pac-remove-shape")
        .setAttribute("disabled", "disabled");
    }
  } else {
    document
      .getElementById("pac-remove-line-seg")
      .setAttribute("disabled", "disabled");
    document
      .getElementById("pac-remove-shape")
      .setAttribute("disabled", "disabled");
  }
}

// This example requires the Drawing library. Include the libraries=drawing
// parameter when you first load the API. For example:
// <script src="https://maps.googleapis.com/maps/api/js?key=YOUR_API_KEY&libraries=drawing">
var map;
//var dbZoneShapes= [];
function initMap() {
  var restroLat = JSON.parse($("#res-lat").val()); //29.757192;
  var restroLng = JSON.parse($("#res-lng").val()); // 78.539184;

  map = new google.maps.Map(document.getElementById("map"), {
    center: { lat: restroLat, lng: restroLng },
    zoom: 10,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    //disableDefaultUI: true
  });
  const marker = new google.maps.Marker({
    // The below line is equivalent to writing:
    //   position: new google.maps.LatLng("restroLat", "restroLng"),
    position: { lat: restroLat, lng: restroLng },
    map: map,
  });

  // You can use a LatLng literal in place of a google.maps.LatLng object when
  // creating the Marker object. Once the Marker object is instantiated, its
  // position will be available as a google.maps.LatLng object. In this case,
  // we retrieve the marker's position using the
  // google.maps.LatLng.getPosition() method.
  const infowindow = new google.maps.InfoWindow({
    content: "<p>Restaurant Location : " + marker.getPosition() + "</p>",
  });
  google.maps.event.addListener(marker, "click", () => {
    infowindow.open(map, marker);
  });

  // Create the search box and link it to the UI element.

  //<input id="pac-input" class="pac-input-text controls" style="width:200px" type="text" placeholder2="Search Location" />
  //<button id="pac-remove-shape" onclick="removeShape()" disabled class="pac-buttons" style="width:120px">Remove Shape</button>
  //<button id="pac-remove-line-seg" onclick="removeLineSegment()" disabled class="pac-buttons" style="width:100px">Undo Polygon</button>

  setTimeout(function () {
    addControlsOnMap();
  }, 200);
  ///// Display all controls
  //document.getElementById('pac-remove-shape').style.display = "block";

  ///////////////////////////////////
  showDrawingManager(map);
  //////////////////////////////////////////////
}

function addControlsOnMap() {
  var inputSearch = document.createElement("input");
  inputSearch.id = "pac-input";
  inputSearch.placeholder = "Search Location";
  inputSearch.className = "pac-input-text controls";
  inputSearch.style = "width:200px";

  var buttonRemoveShape = document.createElement("input");
  buttonRemoveShape.id = "pac-remove-shape";
  buttonRemoveShape.type = "button";
  buttonRemoveShape.className = "pac-buttons";
  buttonRemoveShape.value = "Remove Shape";
  buttonRemoveShape.style = "width:120px";
  buttonRemoveShape.disabled = true;
  //buttonRemoveShape.click = "removeShape()";

  var buttonRemoveLineSegment = document.createElement("input");
  buttonRemoveLineSegment.id = "pac-remove-line-seg";
  buttonRemoveLineSegment.type = "button";
  buttonRemoveLineSegment.className = "pac-buttons";
  buttonRemoveLineSegment.value = "Undo Polygon";
  buttonRemoveLineSegment.style = "width:100px";
  buttonRemoveLineSegment.disabled = true;
  //buttonRemoveLineSegment.click = "removeLineSegment()";

  //const input = document.getElementById("pac-input");
  var searchBox = new google.maps.places.SearchBox(inputSearch);

  try {
    map.controls[google.maps.ControlPosition.TOP_CENTER].pop(inputSearch);
    map.controls[google.maps.ControlPosition.TOP_CENTER].pop(buttonRemoveShape);
    map.controls[google.maps.ControlPosition.TOP_CENTER].pop(
      buttonRemoveLineSegment
    );
  } catch (e) {
    alert(e);
  }

  map.controls[google.maps.ControlPosition.TOP_CENTER].push(inputSearch);
  map.controls[google.maps.ControlPosition.TOP_CENTER].push(buttonRemoveShape);
  map.controls[google.maps.ControlPosition.TOP_CENTER].push(
    buttonRemoveLineSegment
  );

  // Bias the SearchBox results towards current map's viewport.
  map.addListener("bounds_changed", () => {
    searchBox.setBounds(map.getBounds());
  });

  let markers = [];
  // Listen for the event fired when the user selects a prediction and retrieve
  // more details for that place.
  searchBox.addListener("places_changed", () => {
    const places = searchBox.getPlaces();

    if (places.length == 0) {
      return;
    }
    // Clear out the old markers.
    markers.forEach((marker) => {
      marker.setMap(null);
    });
    // markers = [];
    // For each place, get the icon, name and location.
    const bounds = new google.maps.LatLngBounds();
    places.forEach((place) => {
      if (!place.geometry || !place.geometry.location) {
        return;
      }
      const icon = {
        url: place.icon,
        size: new google.maps.Size(71, 71),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(17, 34),
        scaledSize: new google.maps.Size(25, 25),
      };
      // Create a marker for each place.
      markers.push(
        new google.maps.Marker({
          map,
          icon,
          title: place.name,
          position: place.geometry.location,
        })
      );

      if (place.geometry.viewport) {
        // Only geocodes have viewport.
        bounds.union(place.geometry.viewport);
      } else {
        bounds.extend(place.geometry.location);
      }
    });
    map.fitBounds(bounds);
  });
}

function showDrawingManager(map) {
  const drawingManager = new google.maps.drawing.DrawingManager({
    drawingControl: true,
    drawingControlOptions: {
      position: google.maps.ControlPosition.TOP_CENTER,
      drawingModes: [
        google.maps.drawing.OverlayType.CIRCLE,
        google.maps.drawing.OverlayType.POLYGON,
      ],
    },
    markerOptions: {
      icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
    },
    circleOptions: {
      fillColor: "#BCDCF9",
      fillOpacity: 0.5,
      strokeWeight: 2,
      strokeColor: "#57ACF9",
      clickable: true,
      editable: true,
      draggable: true,
      zIndex: 0,
    },
    polygonOptions: {
      fillColor: "#BCDCF9",
      fillOpacity: 0.5,
      strokeWeight: 2,
      strokeColor: "#57ACF9",
      clickable: true,
      editable: true,
      draggable: true,
      zIndex: 0,
    },
  });

  drawingManager.setMap(map);

  google.maps.event.addListener(
    drawingManager,
    "overlaycomplete",
    function (e) {
      if (e.type != google.maps.drawing.OverlayType.MARKER) {
        // Switch back to non-drawing mode after drawing a shape.
        drawingManager.setDrawingMode(null);

        // Add an event listener that selects the newly-drawn shape when the user
        // mouses down on it.
        var newShape = e.overlay;
        newShape.type = e.type;
        _shapes.push(newShape); // store reference to added overlay

        /// Circle
        if (newShape.type === google.maps.drawing.OverlayType.CIRCLE) {
          google.maps.event.addListener(
            newShape,
            "radius_changed",
            function () {
              _shapes[selectedShapeIndexInArray] = newShape;
            }
          );
          google.maps.event.addListener(
            newShape,
            "center_changed",
            function () {
              _shapes[selectedShapeIndexInArray] = newShape;
            }
          );
        }

        /// Polygon
        if (newShape.type === google.maps.drawing.OverlayType.POLYGON) {
          google.maps.event.addListener(
            newShape.getPath(),
            "set_at",
            function () {
              // alert("coordinates changed...");
              _shapes[selectedShapeIndexInArray] = newShape;
            }
          );
          google.maps.event.addListener(
            newShape.getPath(),
            "insert_at",
            function () {
              // alert("coordinates changed...");
              _shapes[selectedShapeIndexInArray] = newShape;
            }
          );
        }

        google.maps.event.addListener(newShape, "click", function () {
          setSelection(newShape);
        });
        setSelection(newShape);
      }
    }
  );

  return drawingManager;
}

function setAlreadyAddedCircles(map) {
  for (var i = 0; i < existingCircleList.length; i++) {
    var exCircle = existingCircleList[i];
    var addedCircle = new google.maps.Circle({
      map: map,
      fillColor: "#BCDCF9",
      fillOpacity: 0.5,
      strokeWeight: 2,
      strokeColor: "#57ACF9",
      clickable: true,
      zIndex: 1,
      center: exCircle.center, // { "lat": 29.764344969203822, "lng": 78.95941105078126 },
      radius: exCircle.radius, //37595.057513952896,
    });

    addedCircle["type"] = "circle";
    _shapes.push(addedCircle); // store reference to added overlay
    setExistingCircleListeners(addedCircle);
  }
}
function setExistingCircleListeners(addedCircle) {
  google.maps.event.addListener(addedCircle, "click", function () {
    setSelection(addedCircle);
  });
  google.maps.event.addListener(addedCircle, "radius_changed", function () {
    _shapes[selectedShapeIndexInArray] = addedCircle;
  });
  google.maps.event.addListener(addedCircle, "center_changed", function () {
    _shapes[selectedShapeIndexInArray] = addedCircle;
  });
}

function setAlreadyAddedPolygons(map) {
  for (var i = 0; i < existingPolygonList.length; i++) {
    var exPoly = existingPolygonList[i];

    var addedPolygon = new google.maps.Polygon({
      name: "poly" + i.toString(),
      path: exPoly,
      geodesic: false,
      map: map,
      fillColor: "#BCDCF9",
      fillOpacity: 0.5,
      strokeWeight: 2,
      strokeColor: "#57ACF9",
      clickable: true,
      zIndex: 1,
    });
    addedPolygon["type"] = "polygon";
    _shapes.push(addedPolygon); 
    setExistingPolygonListeners(addedPolygon);
  }
}
function setExistingPolygonListeners(addedPolygon) {
  google.maps.event.addListener(
    addedPolygon.getPath(),
    "insert_at",
    function () {
      // alert("coordinates changed...");
      _shapes[selectedShapeIndexInArray] = addedPolygon;
    }
  );
  google.maps.event.addListener(addedPolygon.getPath(), "set_at", function () {
    _shapes[selectedShapeIndexInArray] = addedPolygon;
  });
  google.maps.event.addListener(addedPolygon, "click", function () {
    setSelection(addedPolygon);
  });
}

function getShapeRadiusNVertices() {
  var arrMapZoneShapeDetails = [];
  for (var shapeIndex = 0; shapeIndex < _shapes.length; shapeIndex++) {
    var objMapZoneShapeDetails = {};

    var singleShape = _shapes[shapeIndex];
    //document.getElementById('info').innerHTML += "<br><strong> Shape Type : " + singleShape.type + "<strong>";
    objMapZoneShapeDetails.type = singleShape.type;

    if (singleShape.type == google.maps.drawing.OverlayType.POLYGON) {
      var len = singleShape.getPath().getLength();
      var htmlPolyStr = "[";
      for (var i = 0; i < len; i++) {
        var _coordinate = singleShape
          .getPath()
          .getAt(i)
          .toUrlValue(5)
          .split(",");
        htmlPolyStr +=
          '{"lat":' + _coordinate[0] + ',"lng":' + _coordinate[1] + "}";
        if (i < len - 1) {
          htmlPolyStr += ",";
        }
      }
      htmlPolyStr += "]";

      objMapZoneShapeDetails.polygon = htmlPolyStr;
    } else if (singleShape.type == google.maps.drawing.OverlayType.CIRCLE) {
      var htmlCircleStr =
        '{"center":{"lat":' +
        singleShape.getCenter().lat() +
        ',"lng":' +
        singleShape.getCenter().lng() +
        '},"radius":' +
        singleShape.getRadius() +
        "}";
      objMapZoneShapeDetails.circle = htmlCircleStr;
    }
    arrMapZoneShapeDetails.push(objMapZoneShapeDetails);
  }
  return arrMapZoneShapeDetails;
}

function setShapesOnMap(_existingCircleList, _existingPolygonList) {
  removeAllShape();
  //initMap();
  existingCircleList.push({
    center: { lat: 42.900771758745925, lng: -74.33491249638517 },
    radius: 4040.1004911162445,
  });
  existingCircleList.push({
    center: { lat: 30.5340662765232, lng: 79.48128746756896 },
    radius: 47813.663070614406,
  });
  existingCircleList.push({
    center: { lat: 28.661706792094847, lng: 78.93267577691387 },
    radius: 51721.54756250082,
  });

  existingPolygonList.push([
    { lat: 29.99773, lng: 80.32721 },
    { lat: 30.83147, lng: 80.40961 },
    { lat: 30.45338, lng: 81.7005 },
    { lat: 29.35342, lng: 81.12372 },
    { lat: 29.15213, lng: 79.64606 },
    { lat: 29.90254, lng: 79.94269 },
    { lat: 29.87872, lng: 80.28876 },
  ]);
  existingPolygonList.push([
    { lat: 30.5575, lng: 76.76215 },
    { lat: 30.90691, lng: 77.5202 },
    { lat: 30.14509, lng: 77.7619 },
    { lat: 29.28158, lng: 77.67401 },
    { lat: 29.56865, lng: 78.33319 },
    { lat: 28.91679, lng: 78.36615 },
    { lat: 28.89275, lng: 76.73468 },
    { lat: 29.43478, lng: 77.16864 },
    { lat: 29.85491, lng: 77.58612 },
    { lat: 29.31511, lng: 76.58087 },
    { lat: 29.73096, lng: 76.48749 },
    { lat: 29.92634, lng: 77.19611 },
    { lat: 30.38232, lng: 77.45428 },
    { lat: 30.52911, lng: 77.3609 },
  ]);

  setAlreadyAddedCircles(map);
  setAlreadyAddedPolygons(map);
}

function resetMap() {
  setTimeout(function () {
    addControlsOnMap();
  }, 200);

  google.maps.event.trigger(map, "resize");
  var restroLat = JSON.parse($("#res-lat").val()); //29.757192;
  var restroLng = JSON.parse($("#res-lng").val()); // 78.539184;
  map.setCenter(new google.maps.LatLng(restroLat, restroLng));
  map.zoom = 10;
  //map.setZoom(map.getZoom());
  removeAllShape();
}

$(document).on("click", "input#pac-remove-shape", function () {
  //$('input#pac-remove-shape').on('click', function () {
  //function removeShape() {
  if (selectedShape) {
    selectedShape.setMap(null);
    _shapes = removeA(_shapes, selectedShape);
  }
  setSelection(null);
});

$(document).on("click", "input#pac-remove-line-seg", function () {
  //$('input#pac-remove-line-seg').on('click', function () {
  //function removeLineSegment() {
  // var lastOverlay = overlaysLineWiseShape.length > 0 ? overlaysLineWiseShape[overlaysLineWiseShape.length - 1] : null;
  var lastOverlay = selectedShape;
  if (
    lastOverlay &&
    lastOverlay.type === google.maps.drawing.OverlayType.POLYGON
  ) {
    var path = lastOverlay.getPath();
    path.pop(); // remove last line segment

    if (path.length === 0) {
      var lastOverlay = selectedShape; // _shapes.pop();
      if (lastOverlay) {
        lastOverlay.setMap(null);
        _shapes = removeA(_shapes, lastOverlay);
        setSelection(null);
      }
    }
  }
});

function removeAllShape() {
  for (var i = 0; i < _shapes.length; i++) {
    _shapes[i].setMap(null);
  }
  _shapes = [];
}

function arrayIndexOfValue(arr) {
  var what,
    a = arguments,
    L = a.length,
    ax;
  while (L > 1 && arr.length) {
    what = a[--L];
    while ((ax = arr.indexOf(what)) !== -1) {
      return ax;
    }
  }
  return -1;
}

function removeA(arr) {
  var what,
    a = arguments,
    L = a.length,
    ax;
  while (L > 1 && arr.length) {
    what = a[--L];
    while ((ax = arr.indexOf(what)) !== -1) {
      arr.splice(ax, 1);
    }
  }
  return arr;
}
